import React from 'react';

type ModuleHeadProps = {
  alignment: 'text-left' | 'text-center' | 'text-right' | undefined;
  align_lists?: boolean;
  is_hero?: boolean;

  title: string | undefined;
  subtitle: string | undefined;
  description: string | React.ReactNode | undefined;

  color_title: string | undefined;
  color_subtitle: string | undefined;
  color_description: string | undefined;

  remove_margin: boolean;
  className?: string;
}

export class ModuleHeadV2 extends React.Component<ModuleHeadProps> {

  /** component display name */
  displayName = "ModuleHeadV2";

  /** component default props */
  static defaultProps = {
    alignment: 'text-left',
    color_title: '#333',
    color_subtitle: '#333',
    color_description: '#333',
    align_lists: false,
    remove_margin: false,
    className: '',
  };

  /** get margin value (alignment dependant) */
  get margin() {
    let margin =  '';
    if (this.props.alignment === 'text-right') margin = 'm-auto mr-0';
    if (this.props.alignment === 'text-center') margin = 'm-auto';
    return margin;
  }

  /** get alignment value */
  get alignment() {
    if(this.props.alignment === "text-center" && this.props.align_lists) return `${this.props.alignment} [&_ul]:flex [&_ul]:items-center [&_ul]:flex-col [&_ol]:flex [&_ol]:items-center [&_ol]:flex-col`
    if(this.props.alignment === "text-right" && this.props.align_lists) return `${this.props.alignment} [&_ul]:flex [&_ul]:items-end [&_ul]:flex-col [&_ol]:flex [&_ol]:items-end [&_ol]:flex-col`
    return this.props.alignment;
  }

   /** subtitle row */
  get subtitle() {
    if (this.props.subtitle && this.props.subtitle !== '')
      return <div className={`tracking-wide highlighted mb-1`} style={{color: this.props.color_subtitle}}>{this.props.subtitle}</div>
    return null;
  }

  /** title row */
  get title() {
    if (this.props.title && this.props.title !== ''){
      let headlineClasname = "headline3";
      if (this.props.is_hero) headlineClasname = "headline1";
      return <h2 className={`tracking-tight  mb-2 ${headlineClasname}`} style={{color: this.props.color_title}}>{this.props.title}</h2>
    }
    return null;
  }

  /** description */
  get description() {
    if (this.props.description && this.props.description !== '')
      return <div className={`generalText2`} style={{color: this.props.color_description}}>
        {this.props.description}
      </div>
    return null
  }


  render() {
    if(!this.title && !this.subtitle && !this.description) return null;
    return (
      <div className={`module-head ${this.alignment} ${this.margin} ${this.props.remove_margin ? "" : "mb-6 sm:mb-8"} ${this.props.className}`}>
        {this.subtitle}
        {this.title}
        {this.description}
      </div>
    );
  }
}
